import "./OurStory.module.css";
import Header from "@/reusable_sections/Header";
import TheVisionaries from "./sections/TheVisionaries";
import MeetTheTeam from "./sections/MeetTheTeam";
import Footer from "@/reusable_sections/Footer";
export default function OurStoryPage() {
  return <div>
      <Header />
      <TheVisionaries />
      <MeetTheTeam />
      <Footer />
    </div>;
}